import groq from 'groq'

import { linkPageFragment } from '@data/sanity/queries/link'

const frameBuilderStandardSizeFragment = groq`
  _id,
  title,
  width,
  height,
  link {
    ...,
    page->{
      ${linkPageFragment}
    },
  },
`

const frameBuilderProductStandardSizeFragment = groq`
  _id,
  title,
  width,
  height,
`

export const frameBuilderStandardSizeObjectFragment = groq`
  "standardSizes": *[
    _type == "frameBuilderStandardSize" &&
    locale == $locale
  ]
    | order(order asc)
  {
    ${frameBuilderStandardSizeFragment}
  },
`

export const frameBuilderProductStandardSizeObjectFragment = groq`
  "standardSizes": *[
    _type == "frameBuilderStandardSize" &&
    locale == $locale
  ]
    | order(order asc)
  {
    ${frameBuilderProductStandardSizeFragment}
  },
`
